import { useEffect, useRef } from 'react';

// Custom hook to compare previous and current values
export const usePrevious = <T>(value: T): T | undefined => {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};
